function getId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);

    return (match && match[2].length === 11)
      ? match[2]
      : null;
}

$(".video-wrap").each(function () {
    const videoWrap = $(this);
    const video = videoWrap.find('a.video-mp4, button.video-mp4');
    const thisVideoSrc = video.data('src');
    const thisVTTSrc = video.data('vtt-src');
    const thisVTTLabel = video.data('vtt-label');
    const thisVTTSrcLang = video.data('vtt-srclang');

    video.on( "click", function() {
        const videoHTML = '<video class="video" autoplay controls>'+
                            '<source src="'+thisVideoSrc+'" type="video/mp4" />'+
                            '<track label="'+thisVTTLabel+'" kind="subtitles" srclang="'+thisVTTSrcLang+'" src="'+thisVTTSrc+'" />'+
                        '</video>'
        video.replaceWith(videoHTML);
    });
});

$(".video-wrap-youtube").each(function () {
    const videoWrap = $(this);
    const video = videoWrap.find('a.video-youtube, button.video-youtube');
    const thisVideoSrc = video.data('src');
    const thisVideoTitle = video.data('title');

    const videoId = getId(thisVideoSrc);

    video.on( "click", function() {
        const videoHTML = '<iframe class="video" src="//www.youtube.com/embed/'+videoId+'" title="'+thisVideoTitle+'" allowfullscreen></iframe>'
        video.replaceWith(videoHTML);
    });
});